import create from "./create";
import form from "./form";
import manage from "./manage";

const dadup = {
	create: create,
	form: form,
	manage: manage,
	nav: {
		create: "Erstellen",
		manage: "Verwalten",
		title: "daDup Storage",
	},
	title: "Tuxis daDup Storage-Konto",
};

export default dadup;
